module.exports = __webpack_public_path__ + "img/loginout-light.9659148f.png";